/** Türkçe metinden kimlik önerisi (küçük harf, Latin, tire); var olanlarla çakışırsa sona sayı eklenir. */
export function idFrom(text: string, taken: readonly string[], fallback: string): string {
  const base =
    text
      .toLocaleLowerCase('tr')
      .normalize('NFD')
      .replace(/\p{M}/gu, '')
      .replace(/ı/g, 'i')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 32) || fallback;
  let id = /^[a-z0-9]/.test(base) ? base : `${fallback}-${base}`.slice(0, 32);
  let n = 2;
  while (taken.includes(id)) id = `${base.slice(0, 30)}-${n++}`;
  return id;
}
